import { z } from 'zod';
import { bulkCreateTopics } from 'wasp/client/operations';
import type { CsvEntityConfig } from '../types';

const validationSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  slug: z.string().min(1, 'Slug is required'),
  topicTypeKey: z.string().min(1, 'Topic Type Key is required'),
  description: z.string().optional().default(''),
  parentTopicSlug: z.string().optional().default(''),
  isActive: z.string().optional().default('true'),
});

export const topicConfig: CsvEntityConfig = {
  entityName: 'Topics',
  entityNameSingular: 'Topic',
  columns: [
    { key: 'name', label: 'Name', required: true, description: 'Topic name', exampleValue: 'Charity' },
    { key: 'slug', label: 'Slug', required: true, description: 'Unique URL slug', exampleValue: 'Charity' },
    { key: 'topicTypeKey', label: 'Topic Type Key', required: true, description: 'Key of existing topic type', exampleValue: 'pillar' },
    { key: 'description', label: 'Description', required: false, description: 'Optional description', exampleValue: 'Obligatory charity' },
    { key: 'parentTopicSlug', label: 'Parent Topic Slug', required: false, description: 'Slug of parent topic', exampleValue: '' },
    { key: 'isActive', label: 'Is Active', required: false, description: 'true/false (default: true)', exampleValue: 'true' },
  ],
  validationSchema,
  exampleRows: [
    { name: 'Charity', slug: 'Charity', topicTypeKey: 'pillar', description: 'Obligatory charity', parentTopicSlug: '', isActive: 'true' },
    { name: 'Prayer', slug: 'Prayer', topicTypeKey: 'pillar', description: 'Daily prayers', parentTopicSlug: '', isActive: 'true' },
  ],
  bulkCreateAction: bulkCreateTopics as any,
  importNotes: [
    'Topic Type Key must match an existing topic type.',
    'Parent Topic Slug must reference an existing topic.',
  ],
};



